<template>
   <v-container fluid> 

        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>

        <v-tabs v-model="tab" v-if="!loading">
        <v-tab href="#summary" >{{ $t('wkt.admin.assessments.summary') }}</v-tab>
        <v-tab href="#questions" @click="refreshQuestions">{{ $t('wkt.admin.assessments.detail') }}</v-tab>
        <v-tab href="#responses" @click="refreshResponses">{{ $t('wkt.admin.assessments.answers') }}</v-tab>
        </v-tabs>

        <v-tabs-items v-if="!loading" v-model="tab">
            <v-tab-item value="summary">
                <SurveySummary ref="surveySummary"/>
            </v-tab-item>
            <v-tab-item value="questions">
                <QuestionOverview  ref="questionOverview"/>
            </v-tab-item>
            <v-tab-item value="responses">
                <ResponseOverview ref="responseOverview"/>
            </v-tab-item>
        </v-tabs-items>


        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">Cerrar</span>
                </v-btn>
            </v-snackbar>
            
    </v-container>
</template>

<script> 

import QuestionOverview from "./stats/QuestionOverview";
import ResponseOverview from "./stats/ResponseOverview";
import SurveySummary from "./stats/SurveySummary";
import api from '../../api/worktime'

export default {
  name: 'SurveyStatsModule',
  survey: null,
  components: { 
    QuestionOverview,ResponseOverview,SurveySummary
  },
  
  data() {
      return {
        tab: null,
        loading: true,
        submissionInfo: {},
        showAlert: false,
        alertColor: 'error',
        alertText: '',
        alertTimeout: 3000,
      }
  },
   methods: {
       doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    refreshResponses() {
        let me = this;
        setTimeout (function () {
                        me.$refs.responseOverview.refresh(me.survey,me.submissionInfo);
        },200);
    },
    refreshQuestions() {
        let me = this;
        setTimeout (function () {
                        me.$refs.questionOverview.refresh(me.survey,me.submissionInfo);
        },200);
    },
    loadSubmissions() {
        this.loading=true;
        let me = this;
        api.getSurveySubmissions(me.survey.id,
				data => {
					me.submissionInfo=data;
                    me.survey=data.survey;
                    me.loading=false;
                    me.tab='summary';
                    setTimeout (function () {
                        me.$refs.surveySummary.refresh(me.survey,me.submissionInfo);
                    },200);
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
    },
    onReveal(survey) {
        this.survey=survey;
        this.loadSubmissions();
    }
   },
};
</script>
